import { Post, Get, Patch, Put, Delete, Download, ax } from './http';
import { type } from './interface';
import qs from 'qs';
export namespace RoleApi {
    /**
    * 获取角色列表
    */
    export var GetRolesList = (): Promise<any> => {
        return Get(`/msls/RoleApi/getRoleList`, {});
    };
    /**
     * 新增角色/权限
     */
    export var AddRole = (body: any): Promise<any> => {
        return Post(`/msls/RoleApi/createRole`, body);
    };
    /**
     * 修改角色/权限
     */
    export var EditRole = (id: any, body: any): Promise<any> => {
        return Put(`/msls/RoleApi/saveRole/${id}`, body);
    };

    /**
     * 删除角色信息
     */
    export var DelRole = (id: string): Promise<any> => {
        return Delete(`/msls/RoleApi/deleteRole/${id}`, {});
    };
    /**
     * 获取角色、权限详情
     */
    export var GetRoleDetail = (id: any): Promise<any> => {
        return Get(`/msls/RoleApi/getRoleDetail/${id}`, {});
    };
}
